<template>
  <OrdersInvoices namespace="publishers" />
</template>

<script>
import * as apiTo from '@/modular-api'
// Components
import OrdersInvoices from '@/reusable/orders-invoices-tab/OrdersInvoices'

export default {
  components: {
    OrdersInvoices
  },

  provide() {
    return {
      getOrders: this.getOrders,
      getInvoices: this.getInvoices,
      modifyInvoice: this.modifyInvoice
    }
  },

  props: {
    id: [Number, String] // from route
  },

  methods: {
    getOrders() {
      return apiTo.GET_PUBLISHER_ORDERS(this.id)
    },

    getInvoices() {
      return apiTo.GET_PUBLISHER_INVOICES(this.id)
    },

    modifyInvoice(id, payload) {
      return apiTo.MODIFY_VENDOR_INVOICE(id, payload)
    }
  }
}
</script>
